import extenso from 'extenso';

export const CURRENCY_TO_VALUE_MAP: Record<string, string> = {
  KZ: 'kwanzas',
  EUR: 'euros',
  USD: 'dólares',
};

/**
 * Converte um valor (string formatada ou número) para extenso em PT,
 * e concatena o nome da moeda (KZ/EUR/USD) por extenso.
 */
export function toExtensoComMoeda(
  valor: number | string,
  moedaSigla?: string | null
): string {
  // aceita "1.234,56" ou 1234.56
  const n =
    typeof valor === 'string'
      ? Number(String(valor).replace(/\./g, '').replace(',', '.'))
      : Number(valor);

  const numeroExtenso = extenso(isNaN(n) ? 0 : n, { mode: 'number', locale: 'pt' });
  const moedaExtenso = moedaSigla ? CURRENCY_TO_VALUE_MAP[moedaSigla] : undefined;

  return moedaExtenso ? `${numeroExtenso} ${moedaExtenso}` : numeroExtenso;
}
